import styled from "styled-components";

export const UploadCardContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;
